import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'tnq-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CdkTrapFocus, TranslateModule],
})
export class DialogComponent {
  readonly dialogTitle = input.required<string>();
}
